<template>
  <div class="c-modal-board-update">
    <Modal v-model="options.active" @input="closeModal" :closable="true">
      <template v-slot:title>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 6H19M7 3H17M5 21H19C20.1046 21 21 20.1046 21 19V11C21 9.89543 20.1046 9 19 9H5C3.89543 9 3 9.89543 3 11V19C3 20.1046 3.89543 21 5 21Z"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-width="1.5"
          />
        </svg>

        <h3>Update Board</h3>
      </template>
      <template>
        <FormBoardUpdate
          v-if="editId"
          :id="editId"
          :form="board"
          @onSubmit="onSubmit"
        ></FormBoardUpdate>
      </template>
      <template v-slot:footer>
        <div class="c-modal-board-update__meta" v-if="createdByUser">
          <article>
            <span> Created by: </span>
            <p>
              <img :src="`${assetUrl}/${createdByUser.avatar.name}`" />{{
                createdByUser.name
              }}
            </p>
          </article>
          <article v-if="board.createdAt">
            <span> Created on: </span>
            <p>{{ formatDate(board.createdAt) }}</p>
          </article>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from './index.vue';
import { parseISO, format } from 'date-fns';
import FormBoardUpdate from '@swipekit/components/form/form-board-update.vue';

export default {
  components: {
    Modal,
    FormBoardUpdate,
  },

  data: function () {
    return {
      options: {
        name: 'modal-board-update',
        active: false,
      },
    };
  },

  watch: {
    'options.active': {
      handler: function () {},
    },
    editId: {
      handler: function () {
        if (this.editId) {
          this.options.active = true;
        } else {
          this.options.active = false;
        }
      },
      immediate: true,
    },
  },

  computed: {
    assetUrl: function () {
      return this.$store.getters['config/assetUrl'];
    },
    createdByUser: function () {
      if (!this.board) {
        return;
      }
      const userId = this.board.userId;

      let u = null;

      for (let i = 0; i < this.workspace.users.length; i++) {
        const user = this.workspace.users[i];

        if (user.id === userId) {
          u = user;
          break;
        }
      }

      return u;
    },
    workspace: function () {
      return this.$store.getters['workspaces/all'];
    },
    editId: function () {
      return this.$store.getters['boards/editId'];
    },
    board: function () {
      if (!this.editId) {
        return null;
      }
      return this.$store.getters['boards/one'](this.editId);
    },
  },

  methods: {
    formatDate: function (isoDate) {
      let date = parseISO(isoDate);
      let str = format(date, 'do MMM yyyy');

      return str;
    },
    closeModal: function () {
      this.$store.dispatch('boards/setEdit', null);
    },
    onSubmit: function () {
      this.$store.dispatch('triggerExtension', { type: 'boards:update' });
      this.options.active = false;
    },
    activate: function () {
      this.options.active = true;
    },
  },

  mounted: function () {
    //this.options.active = true;
  },
};
</script>

<style lang="scss">
.c-modal-board-update {
  .modal-content {
    overflow: hidden;
    margin: 0 auto;
  }

  .modal-container {
    display: block;
    margin: 0 auto;
  }

  .modal {
    &__title {
      display: flex;
      align-items: center;
      padding: 16px var(--spacer);
      background-color: var(--color-bg-2);
      border-bottom: var(--color-bg-4) solid 1px;

      svg {
        width: 32px;
        height: 32px;
        margin-right: var(--margin-lg);
      }

      h3 {
        margin-bottom: 0;
      }
    }

    &__content {
      padding-top: var(--spacer-sm);
      padding-bottom: var(--spacer-sm);
      background-color: var(--color-bg-1);
    }

    &__footer {
      padding: 16px var(--spacer);
      background-color: var(--color-bg-2);
      border-top: var(--color-bg-4) solid 1px;
    }
  }

  &__meta {
    font-size: var(--font-size-sm);

    article {
      display: grid;
      grid-template-columns: 94px 1fr;
      align-items: center;
      min-height: 24px;
      padding: var(--margin-sm) 0;
    }

    span {
      opacity: 0.75;
    }
    p {
      display: flex;
      align-items: center;
      margin: 0;
    }
    img {
      display: inline-block;
      width: 24px;
      height: 24px;
      border-radius: 99px;
      object-fit: cover;
      margin-right: var(--margin);
    }
  }
}
</style>
